import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

interface GabPaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

export function GabPagination({ page, pageSize, total, onChange }: GabPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between gap-4" style={{ marginTop: 'var(--spacing-4)' }}>
      <span className="text-sm text-muted">
        Showing {start}–{end} of {total.toLocaleString()}
      </span>
      <nav className="pagination" aria-label="Pagination">
        <button className={`page-link${page <= 1 ? ' disabled' : ''}`} onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label="Previous">
          <IconChevronLeft size={14} />
        </button>
        {pages.map((p, i) =>
          p === '...'
            ? <span key={`e${i}`} className="page-link disabled" style={{ border: 'none', cursor: 'default' }}>...</span>
            : <button key={p} className={`page-link${p === page ? ' active' : ''}`} onClick={() => onChange(p as number)}>{p}</button>
        )}
        <button className={`page-link${page >= totalPages ? ' disabled' : ''}`} onClick={() => onChange(page + 1)} disabled={page >= totalPages} aria-label="Next">
          <IconChevronRight size={14} />
        </button>
      </nav>
    </div>
  );
}
